import { MaterialType } from "../../../../types/materials";
import { TagColors } from "../../elements/tags/types";
import { otherMaterial } from "./constants";

export type MaterialOption = MaterialType | typeof otherMaterial;

export const mapMaterialsToTagColors: Record<MaterialOption, TagColors> = {
  [MaterialType.Wood]: TagColors.Wood,
  [MaterialType.Stone]: TagColors.Stone,
  [MaterialType.Glass]: TagColors.Glass,
  [MaterialType.Materia]: TagColors.Materia,
  [MaterialType.Metal]: TagColors.Metal,
  [otherMaterial]: TagColors.Primary,
};

export interface MaterialsFormFieldsTypes {
  materials: Record<MaterialOption, boolean>;
}

export type MaterialsFormFieldsLabels = Record<keyof MaterialsFormFieldsTypes, string | null> &
  Record<MaterialOption, string | null>;
